/* import __COLOCATED_TEMPLATE__ from './adi-generic.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();